"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchiveOfferModalOfferTitle = exports.ArchiveOfferModalHeader = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ArchiveOfferModalHeader = styled_components_1.default.div `
	font-size: 1.4rem;
	font-weight: bold;
`;
exports.ArchiveOfferModalOfferTitle = styled_components_1.default.div `
	font-weight: bold;
	color: ${({ theme }) => theme.color.brand1};
	font-size: 1.1rem;
`;
